import React from 'react';
import * as PropTypes from 'prop-types';
import { Select, Input, DatePicker } from 'antd';
import dayjs from 'dayjs';

const DATE_FORMAT = 'YYYY-MM-DD';
const MONTH_FORMAT = 'YYYY-MM';

// Date filter: single date picker, value stored as YYYY-MM-DD string
const DateFilterInput = ({ values, onChange }) => {
  const value = values && values[0] ? dayjs(values[0], DATE_FORMAT) : null;
  return (
    <DatePicker
      key="date"
      style={{ width: 200 }}
      value={value}
      onChange={(d) => onChange(d ? [d.format(DATE_FORMAT)] : [])}
      format={DATE_FORMAT}
      allowClear
    />
  );
};

// Month filter: month picker, value stored as YYYY-MM-DD (first of month) for Cube
const MonthFilterInput = ({ values, onChange }) => {
  const raw = values && values[0];
  const value = raw ? dayjs(raw.substring(0, 7), MONTH_FORMAT) : null;
  return (
    <DatePicker
      key="month"
      picker="month"
      style={{ width: 200 }}
      value={value}
      onChange={(d) => onChange(d ? [d.format(MONTH_FORMAT) + '-01'] : [])}
      format={MONTH_FORMAT}
      allowClear
    />
  );
};

const FilterInputs = {
  string: ({ values, onChange }) => (
    <Select
      key="input"
      style={{
        width: 300,
      }}
      mode="tags"
      onChange={onChange}
      value={values}
    />
  ),
  number: ({ values, onChange }) => (
    <Input
      key="input"
      style={{
        width: 300,
      }}
      onChange={(e) => onChange([e.target.value])}
      value={(values && values[0]) || ''}
    />
  ),
  time: ({ values, onChange, dimension }) => {
    const isMonth =
      dimension &&
      (String(dimension.name || '').toLowerCase().includes('month') ||
        String(dimension.title || '').toLowerCase().includes('month'));
    const C = isMonth ? MonthFilterInput : DateFilterInput;
    return <C values={values} onChange={onChange} />;
  },
};
FilterInputs.string.propTypes = {
  values: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
FilterInputs.string.defaultProps = {
  values: [],
};
FilterInputs.number.propTypes = {
  values: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
FilterInputs.number.defaultProps = {
  values: [],
};
FilterInputs.time.propTypes = {
  values: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  dimension: PropTypes.object,
};
FilterInputs.time.defaultProps = {
  values: [],
  dimension: null,
};

const FilterInput = ({ member, updateMethods }) => {
  const Filter = FilterInputs[member.dimension.type] || FilterInputs.string;
  return (
    <Filter
      key="filter"
      values={member.values}
      dimension={member.dimension}
      onChange={(values) =>
        updateMethods.update(member, {
          ...member,
          values,
        })
      }
    />
  );
};
FilterInput.propTypes = {
  member: PropTypes.object.isRequired,
  updateMethods: PropTypes.object.isRequired,
};
export default FilterInput;
